import * as yup from 'yup';

const createCompanyFormValidationSchema = (isUpdate) => {
  let schema = yup.object({
    companyName: yup
      .string()
      .required('Company name is required')
      .min(2, 'Company name must be at least 2 characters long'),

    companyEmail: yup
      .string()
      .required('Company email is required')
      .email('Invalid email format'),

    password: yup
      .string()
      .required('Password is required')
      .min(8, 'Password must be at least 8 characters long'),
    // .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/, 'Password must contain at least one uppercase letter, one lowercase letter, and one number'),

    contactPersonName: yup
      .string()
      .required('Contact person name is required')
      .min(2, 'Contact person name must be at least 2 characters long'),

    contactPersonPhone: yup
      .string()
      .required('Contact person phone is required'),
    // .matches(/^\+?([0-9]{1,3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4,6})$/, 'Invalid phone number format'),

    contactPersonEmail: yup
      .string()
      .required('Contact person email is required')
      .email('Invalid email format'),

    companyRegistrationExpiryDate: yup.date().required('Date is required').nullable(),
    companyRegistrationVatNumber: yup.string().required('Vat number is required'),
  });
  if (!isUpdate) {
    schema = schema.shape({
      companyRegistrationDocument: yup.mixed().required('File is required'),
    });
  }
  return schema;
};

export default createCompanyFormValidationSchema;